<template>
  <hr class="divider" :class="{ light: isLight, vertical: vertical }" />
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NDivider extends Vue {
  @Prop({ type: Boolean, default: true }) isLight!: boolean
  @Prop({ type: Boolean, default: false }) vertical!: boolean
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.divider {
  width: 100%;
  height: $notch-space_05x;
  background-color: $notch-color-neutral-sand-200;
  border: 0;

  &.light {
    height: 1px;
  }

  &.vertical {
    width: $notch-space_05x;
    height: 100%;
  }
}
</style>
